"use client";

import { useState } from "react";
import { ChevronLeft } from "lucide-react";
import { Card } from "@/components/ui/card";

import { FAQProps } from "@/types/faq"

export default function FAQAccordion({ faqs = [] }: FAQProps) {

    const [openIndexes, setOpenIndexes] = useState<number[]>([]);

    const toggleAccordion = (idx: number) => {

        setOpenIndexes((prev) =>
            prev.includes(idx)
                ? prev.filter((i) => i !== idx)
                : [...prev, idx]
        );

    };

    if (!faqs.length) {
        return null;
    }

    return (
        <Card className="mt-3 border-0 p-5 hover:shadow-sm">

            <div className="card faqs products">

                <div className="title mb-3 border-b border-b-gray-200 p-2">

                    <h3 className="label text-lg font-bold">
                        سؤالات پرتکرار
                    </h3>

                </div>

                {faqs.map((faq, idx) => {

                    const isOpen = openIndexes.includes(idx);

                    return (
                        <div
                            key={idx}
                            className={`faq-item mb-2 rounded-lg transition ${
                                isOpen
                                    ? "bg-gray-100"
                                    : "bg-white"
                            }`}
                        >

                            <button
                                type="button"
                                onClick={() => toggleAccordion(idx)}
                                className="flex w-full cursor-pointer items-center justify-between rounded-lg p-3 text-right hover:bg-gray-100"
                                aria-expanded={isOpen}
                            >

                                <span className="font-bold leading-8">
                                    {idx + 1}. {faq.subject}
                                </span>

                                <ChevronLeft
                                    className={`h-5 w-5 transition-transform duration-300 ${
                                        isOpen
                                            ? "-rotate-90"
                                            : ""
                                    }`}
                                />

                            </button>

                            {isOpen && (
                                <div
                                    className="faq-body p-3 text-justify leading-8"
                                    dangerouslySetInnerHTML={{
                                        __html: faq.body,
                                    }}
                                />
                            )}

                        </div>
                    );
                })}

            </div>

        </Card>
    );
}
